module.exports = __webpack_public_path__ + "static/media/bg_squid.dad63ede.mp3";